export default {
    getList: {
        getPendList: async function (params) {
            let option = {
                url: '/api/v1/alertwait/partner',
                type: 'get',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminPendWarning.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        getSite: async function (params) {
            let option = {
                url: '/api/v1/alertwait/partner',
                type: 'post',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userPendWarning.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    },
    do: {
        deleteWarning: async function (params) {
            let option = {
                url: '/api/v1/alertwait/partner',
                type: 'delete',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.adminPendWarning.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
        allDelete: async function (params) {
            let option = {
                url: '/api/v1/alertwait/partner',
                type: 'put',
                params: params,
                mock: {
                    state: false,
                    data: this.$mock.userPendWarning.getList.default,
                }
            }
            return await this.$api.handleRequest.call(this, option);
        },
    }
}